import { React, useEffect, useState } from "react";
import ico_handy_orange from "../../../assets/icons/ico_handy_orange.svg";
import ico_huellas_green from "../../../assets/icons/ico_huellas_green.svg";
import ToolsInfoSection from "../../../components/toolsInfoSection";
import ToolsTab from "../../../components/toolsTab";
import VideoBanner from "../../../components/videoBanner";
import img_leopardo_trap from "../../../assets/images/img_leopardo_trap.png";
import img_camara_trampa from "../../../assets/images/img_camara_trampa.png";
import GoToPage from "../../../components/goToPage";
import ToolsActivityButton from "../../../components/toolsActivityButton";
const CameraTrapScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const bosque = "0U8mctMTdwI";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="w-full bg-[#002E0F] h-full overflow-hidden">
      {width > 1279 ? (
        <div >
          <div className="w-full lg:h-[1080px]  absolute ">
            <VideoBanner idVideo={bosque}></VideoBanner>
          </div>
          <div className="w-full mx-auto text-white relative h-fit overflow-hidden">
            <div className="absolute right-0  mb-10">
              <img
              
                src={img_camara_trampa}
                className="-right-[17rem] w-[38rem] h-full relative z-0 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible "
              ></img>
            </div>
            <div className=" absolute">
              <img
              
                src={img_leopardo_trap}
                className=" 2xl:w-[67rem] xl:w-[50rem] lg:w-[50rem] md:w-[50rem] sm:w-[40rem] w-[40rem] ml-[27rem] mt-[21rem]  relative z-0 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible"
              ></img>
            </div>

            <div className="justify-center text-black h-fit text-left pt-[22rem] relative lg:pl-[8rem] md:pl-[3rem] sm:pl-[3rem] pl-[3rem]">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div className="grid mb-52 relative lg:pl-32 md:pl-20 sm:pl-10 pl-10 2xl:pr-0 xl:pr-[15rem] lg:pr-[20rem] md:pr-[5rem] sm:pr-[5rem] pr-[5rem] mr-80 2xl:grid-cols-5 xl:grid-cols-1 lg:grid:cols-1 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 2xl:pb-[10rem] xl:pb-[70rem] lg:pb-[70rem] md:pb-[90rem] sm:pb-[90rem] pb-[90rem] min-w-[10rem] pt-10 w-full  ">
          <div className="text-left h-[50rem] col-span-2 text-black lg:mr-10 sm:bottom-0 bg-white w-full z-10 relative">
                <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Aves y mamíferos"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      Cámaras trampa
                    </h1>
                  }
                  text={
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base lg:pb-[5rem] mg:pb-[5rem] sm:pb-[5rem] pb-[5rem]">
                      El <b>monitoreo con cámaras trampa</b> permite registrar
                      especialmente mamíferos y aves mediante vídeos y
                      fotografías. Las cámaras trampa son{" "}
                      <b>“cámaras escondidas”</b> que se activan gracias a
                      sensores de movimiento o calor.
                    </p>
                  }
                ></ToolsInfoSection>
              </div>
              <div className="relative col-span-3 2xl:mt-[40rem] xl:mt-[0rem] lg:mt-[0rem] md:mt-[0rem] sm:mt-[0rem] mt-[0rem]  items-center">
                <div className="relative w-full h-full items-center  text-white bg-[#002E0F] pr-10 pt-5">
                  <ToolsTab
                   firstTitle="Ruta de paso de animales"
                   secondTitle="Resultados y beneficios"
                    firstTab={
                      <p className="text-xl">
                        Se recomienda colocarlas en parches o remanentes de
                        bosque y recuperar las imágenes frecuentemente (por
                        ejemplo, cada semana o cada mes). El método consiste en
                        colocar la cámara trampa en un árbol o algún soporte
                        similar, en un paso o vereda dentro del bosque que pueda
                        ser un paso de mamíferos. Se puede aplicar en zonas con
                        árboles remanentes en un área urbana.
                      </p>
                    }
                    secondTab={
                      <div>
                        <p className="text-xl mb-5">
                          Tienen la ventaja de que pueden detectar a los
                          animales, tanto de día como de noche y sin la
                          presencia de personas que podrían ahuyentarlos.
                        </p>
                        <p className="text-xl mb-5">
                          Permite detectar animales de hábitos nocturnos.
                        </p>
                        <p className="text-xl mb-5">
                          Son excelentes herramientas de comunicación de
                          resultados de monitoreo.
                        </p>
                        <p className="text-xl mb-5">
                          Evidencia directa de la diversidad de especies.
                        </p>
                        <p className="text-xl mb-5">
                          Demuestra que las medidas de conservación
                          implementadas por las empresas tienen impacto real en
                          las poblaciones naturales.
                        </p>
                      </div>
                    }
                  ></ToolsTab>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="w-full absolute overflow-hidden ">
            <VideoBanner idVideo={bosque}></VideoBanner>
            <div className=" absolute left-0 bottom-0 ">
              <img
              
                src={img_leopardo_trap}
                className="lg:w-[35rem] md:w-[25rem] sm:w-[15rem] w-[15rem] "
              ></img>
            </div>
            <div className=" absolute -right-[8rem] bottom-0">
              <img
              
                src={img_camara_trampa}
                className="lg:w-[35rem] md:w-[25rem] sm:w-[15rem] w-[15rem] "
              ></img>
            </div>
          </div>

          <div className="grid grid-cols-1  2xl:px-52  lg:px-30 md:px-10 sm:px-14 px-10 pb-[40rem]">
            <div className="justify-center text-black h-fit text-left lg:mt-[30rem] md:mt-[15rem] sm:mt-[7rem] mt-[7rem] relative ">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>

            <div className=" h-fit text-black  bg-white w-full z-10 relative bottom-0  mt-[4rem]  ">
              
            <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Aves y mamíferos"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      Cámaras trampa
                    </h1>
                  }
                  text={
                    <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base lg:pb-[10rem] mg:pb-[10rem] sm:pb-[10rem] pb-[10rem]">
                      El <b>monitoreo con cámaras trampa</b> permite registrar
                      especialmente mamíferos y aves mediante vídeos y
                      fotografías. Las cámaras trampa son{" "}
                      <b>“cámaras escondidas”</b> que se activan gracias a
                      sensores de movimiento o calor.
                    </p>
                  }
                ></ToolsInfoSection>
            </div>



            <div className="relative w-full h-full items-center lg:mt-32 md:mt-10 sm:mt-5 mt-5  text-white bg-[#002E0F]">
            <ToolsTab
            firstTitle="Ruta de paso de animales"
            secondTitle="Resultados y beneficios"
                    firstTab={
                      <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                        Se recomienda colocarlas en parches o remanentes de
                        bosque y recuperar las imágenes frecuentemente (por
                        ejemplo, cada semana o cada mes). El método consiste en
                        colocar la cámara trampa en un árbol o algún soporte
                        similar, en un paso o vereda dentro del bosque que pueda
                        ser un paso de mamíferos. Se puede aplicar en zonas con
                        árboles remanentes en un área urbana.
                      </p>
                    }
                    secondTab={
                      <div>
                        <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                          Tienen la ventaja de que pueden detectar a los
                          animales, tanto de día como de noche y sin la
                          presencia de personas que podrían ahuyentarlos.
                        </p>
                        <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                          Permite detectar animales de hábitos nocturnos.
                        </p>
                        <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                          Son excelentes herramientas de comunicación de
                          resultados de monitoreo.
                        </p>
                        <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                          Evidencia directa de la diversidad de especies.
                        </p>
                        <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                          Demuestra que las medidas de conservación
                          implementadas por las empresas tienen impacto real en
                          las poblaciones naturales.
                        </p>
                      </div>
                    }
                  ></ToolsTab>
            </div>
          </div>

        </div>
      )}
    </div>
  );
};

export default CameraTrapScreen;
